(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
  
  function initTabs() {
    // Find all tab sections
    const tabSections = document.querySelectorAll('.properties-tabing-section');
    
    tabSections.forEach(function(section) {
      const navItems = section.querySelectorAll('.tabing-nav-item');
      const panels = section.querySelectorAll('.tabing-panel');
      
      if (navItems.length === 0 || panels.length === 0) return;
      
      // Remove any existing active states
      function deactivateAll() {
        navItems.forEach(function(item) {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function(panel) {
          panel.classList.remove('active');
        });
      }
      
      // Activate a specific tab
      function activateTab(index) {
        if (index < 0 || index >= navItems.length) return;
        
        deactivateAll();
        
        navItems[index].classList.add('active');
        navItems[index].setAttribute('aria-selected', 'true');
        panels[index].classList.add('active');
      }
      
      // Click handler for tabs
      navItems.forEach(function(item, index) {
        item.addEventListener('click', function(e) {
          activateTab(index);
        });
        
        // Keyboard accessibility
        item.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateTab(index);
          }
        });
        
        // Set initial ARIA attributes
        item.setAttribute('role', 'tab');
        item.setAttribute('tabindex', '0');
      });
      
      // Set initial ARIA attributes for panels
      panels.forEach(function(panel, index) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', 'tab-' + index);
      });
      
      // Ensure first tab is active by default
      const hasActiveTab = section.querySelector('.tabing-nav-item.active');
      if (!hasActiveTab && navItems.length > 0) {
        activateTab(0);
      }
    });
  }
  
})();